import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Overflow } from '@sas/react-svg';
import { setRef } from '../../../../util/ref-util';
import { BaseMenuButton } from '../../../MenuButton/__internal__';

/**
 * The IconMenuButton used in ListColumnProps.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const IconMenuButton = /*#__PURE__*/forwardRef(function IconMenuButton(props, ref) {
  const {
    onItemSelected,
    onOpen,
    onDismiss,
    onItemClosed,
    buttonRef,
    ...restProps
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const menuButtonRef = useRef(null);
  const isProgrammaticClick = useRef(false);
  useImperativeHandle(ref, () => ({
    toggle: () => {
      const newIsOpen = !isOpen;
      setIsOpen(newIsOpen);
      isProgrammaticClick.current = true;
      menuButtonRef.current?.click();
      isProgrammaticClick.current = false;
      return newIsOpen;
    },
    isOpen
  }));
  const handleClick = event => {
    if (event.target === menuButtonRef.current && isProgrammaticClick.current) {
      event.stopPropagation();
    }
  };
  const handleKeyDown = event => {
    if (isOpen) event.stopPropagation();
  };
  const handleKeyUp = event => {
    if (isOpen) event.stopPropagation();
  };
  const handleItemSelected = (location, key) => {
    onItemSelected?.(location, key);
    setIsOpen(false);
  };
  const handleOpen = () => {
    onOpen?.();
    setIsOpen(true);
  };
  const handleDismiss = () => {
    onDismiss?.();
    setIsOpen(false);
  };
  return /*#__PURE__*/_jsx("div", {
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    children: /*#__PURE__*/_jsx(BaseMenuButton, {
      icon: {
        icon: Overflow
      },
      ...restProps,
      ref: button => {
        setRef(buttonRef, button);
        setRef(menuButtonRef, button);
      },
      onItemSelected: handleItemSelected,
      onOpen: handleOpen,
      onDismiss: handleDismiss,
      focusable: false
    })
  });
});
//# sourceMappingURL=IconMenuButton.js.map